import classNames from 'classnames';
import React__default from 'react';
import { s as styleInject } from '../style-inject.es-e7b07dd7.js';
import Button from './Button.js';
import '../consts.js';
import 'wix-rich-content-common';

var css_248z = ".vodN5{display:flex;flex-direction:row-reverse;gap:12px;width:100%}.vodN5.ziHt1{justify-content:space-between}";
var styles = {"action_buttons":"vodN5","mobile":"ziHt1"};
styleInject(css_248z);

const ActionButtons = ({
  size,
  onCancel,
  onSave,
  cancelText,
  saveText,
  isMobile = false,
  disableSave = false,
  children,
  t
}) => {
  const saveLabel = saveText || t("SettingsPanelFooter_Save");
  const cancelLabel = cancelText || t("SettingsPanelFooter_Cancel");
  const buttonsDataHook = { save: "actionButtonSave", cancel: "actionButtonCancel" };
  const isSecondary = true;
  const isDisabled = false;
  const renderButton = (text, dataHook, onClick, disabled = false, secondary = false) => /* @__PURE__ */ React__default.createElement(
    Button,
    {
      size,
      ariaLabel: text,
      disabled,
      isMobile,
      dataHook,
      onClick,
      secondary
    },
    text
  );
  return /* @__PURE__ */ React__default.createElement("div", { className: classNames(styles.action_buttons, { [styles.mobile]: isMobile }) }, renderButton(saveLabel, buttonsDataHook.save, onSave, disableSave), children, renderButton(cancelLabel, buttonsDataHook.cancel, onCancel, isDisabled, isSecondary));
};

export { ActionButtons as default };
//# sourceMappingURL=ActionButtons.js.map
